import {
  EBIcon,
  IconConfig,
  IconConfigVariant,
  IconStateConfig,
} from '@repo/sdk/models/components';

import { getActiveState } from '@/features/equipment-browser/conditional-evaluator/get-active-state';
import { getRefValue } from '@/features/equipment-browser/utils';

// Main function to get the animatic shelf configs for an equipment
export const getDeviceIconConfig = (
  deviceIcon?: EBIcon | undefined,
  fallbackIconName?: string,
  allowEmpty = false
): IconConfig | undefined => {
  const defaultIconConfig: IconConfig = {
    icon: fallbackIconName ?? 'Settings',
    isPulsing: false,
    variant: IconConfigVariant.Default,
  };
  if (!deviceIcon) {
    return allowEmpty ? undefined : defaultIconConfig;
  }

  const activeIconState = getActiveState<IconStateConfig>({
    states: deviceIcon.states,
  });

  if (!activeIconState) {
    return allowEmpty ? undefined : defaultIconConfig;
  }

  if (activeIconState.config) {
    // Copy the config to avoid mutating the original
    const config = { ...activeIconState.config };
    // If the tooltip content has a ref and no value, set the value to the ref value
    if (config.tooltipContent?.ref && !config.tooltipContent.value) {
      config.tooltipContent.value = getRefValue(config.tooltipContent.ref)?.toString();
    }
    return config;
  }

  if (activeIconState.iconRefMap && activeIconState.iconRefMap.ref) {
    const refValue = getRefValue(activeIconState.iconRefMap.ref);
    if (refValue) {
      const iconConfig =
        activeIconState.iconRefMap.iconMap?.[refValue.toString()] ?? defaultIconConfig;
      return {
        ...iconConfig,
        // Set the tooltip content to the ref value (Mode)
        tooltipContent: {
          value: refValue.toString(),
        },
      };
    }
  }

  return allowEmpty ? undefined : defaultIconConfig;
};
